import { useTranslation } from "../../../i18n/I18nContext";
import { LANDING_MAX, LANDING_PAD_X } from "./landingLayout";

export function LandingFeatures() {
  const { t } = useTranslation();
  const features = [
    { icon: "/icons/growth.webp", title: t("features.item1Title"), desc: t("features.item1Desc") },
    { icon: "/icons/calendar.webp", title: t("features.item2Title"), desc: t("features.item2Desc") },
    { icon: "/icons/decision-making.webp", title: t("features.item3Title"), desc: t("features.item3Desc") },
    { icon: "/icons/acknowledgement.webp", title: t("features.item4Title"), desc: t("features.item4Desc") },
  ];
  return (
    <section
      id="features"
      aria-labelledby="features-title"
      className="w-full bg-[#F1F5FF] py-12 sm:py-14 lg:py-[76px]"
    >
      <div className={`${LANDING_MAX} ${LANDING_PAD_X}`}>
        <div className="flex flex-col gap-10 sm:gap-12 lg:gap-[50px]">
          <div className="flex flex-col gap-5 text-center sm:gap-6 lg:gap-[25px]">
            <h2
              id="features-title"
              className="font-bold leading-[1.3] text-[28px] sm:text-[34px] lg:text-5xl xl:text-[48px]"
            >
              {t("features.title")}{" "}
              <span className="text-primary">{t("features.titleHighlight")}</span>
            </h2>
            <p className="text-base leading-relaxed sm:text-lg lg:text-[20px] lg:leading-[32.5px]">
              {t("features.subtext")}
            </p>
          </div>
          <div className="grid grid-cols-1 gap-6 sm:gap-7 lg:grid-cols-2 lg:gap-[30px]">
            {features.map((f, i) => (
              <div
                key={i}
                className="flex flex-col items-start gap-5 rounded-[24px] border border-white/60 bg-white px-5 py-7 shadow-figma-card transition-shadow hover:shadow-[0_8px_32px_rgba(58,78,139,0.18)] sm:px-6 sm:py-8 lg:flex-row"
              >
                <img src={f.icon} alt="" className="h-[65px] w-[65px] shrink-0 rounded-[10px]" aria-hidden />
                <div className="min-w-0 flex-1">
                  <h3 className="mb-2.5 font-semibold text-[#253477] text-xl leading-7 sm:text-2xl">{f.title}</h3>
                  <p className="text-[16px] leading-[140%] sm:text-[18px]">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
